<template>
  <div
    v-if="activeTab == 'nextSevenDays'"
    class="apt-pass-filters d-flex flex-wrap align-items-start gap-3 p-2 w-100 min-w-0"
  >
    <div class="d-flex flex-wrap align-items-center gap-2 min-w-0 flex-grow-1">
      <span class="flex-shrink-0">Quick filters:</span>
      <CustomDropDown
        aria-label="Quick filters"
        :toggler-text="state.quickFilter.label"
        class="apt-pass-filter-dropdown"
        :options="state.selectorsOptions.quickFilter"
        @item-click="setQuickFilter"
      >
      </CustomDropDown>
    </div>
    <div class="d-flex flex-wrap align-items-center gap-2 min-w-0 flex-grow-1">
      <span class="flex-shrink-0">Pass Types:</span>
      <CustomDropDown
        aria-label="Pass types"
        :selected-label="passTypeSelectLabel"
        :toggler-text="state.quickFilter.label"
        class="apt-pass-filter-dropdown"
        :options="state.selectorsOptions.passType"
        @item-click="setPassType"
        :selected-items="passType"
      >
      </CustomDropDown>
    </div>
  </div>
</template>

<script>
import CustomDropDown from "@/v3components/shared/Form/CustomDropDown.vue"

import { useStore } from "vuex"
import { computed, reactive } from "vue"
export default {
  name: "AdultAptPassFilters",
  components: { CustomDropDown },
  setup() {
    const store = useStore()

    const state = reactive({
      quickFilter: "All Passes",
      passType: "All Types",
      selectorsOptions: {
        quickFilter: [
          { label: "All Passes", value: "" },
          { label: "Just My Created", value: "just_my_created" },
          { label: "From Me", value: "from_me" },
          { label: "To me", value: "to_me" },
          { label: "To & From Others", value: "to_and_from_others" }
        ],
        passType: [
          { label: "All Types", value: "" },
          { label: "Activated", value: "type_activated" },
          { label: "Missed APT", value: "type_missed_apt" },
          { label: "Canceled", value: "type_canceled" },
          { label: "Missed Request", value: "type_missed" },
          { label: "Future APT", value: "type_future" },
          { label: "Needs Confirmation", value: "needs_confirmation" },
          { label: "Ended", value: "type_ended" },
          { label: "On Other Pass", value: "type_on_other_pass" }
        ]
      }
    })

    const quickFilter = computed(
      () => store.getters["adultAptPass/quickFilter"]
    )
    const passType = computed(() => store.getters["adultAptPass/passType"])
    const activeTab = computed(() => store.getters["adultAptPass/activeTab"])

    const passTypeSelectLabel = computed(() => {
      if (passType.value.length) {
        const count =
          passType.value.length > 1 ? " +" + (passType.value.length - 1) : ""
        const label = passType.value[passType.value.length - 1].label
        return label + count
      }
      return ""
    })

    const setQuickFilter = (item) => {
      store.commit("adultAptPass/SET_QUICK_FILTER", item)
      store.commit("dashboardTable/SET_DASHBOARD_UPDATES", false)
      store.dispatch("adultAptPass/getAppointmentPasses")
    }

    const setPassType = (item) => {
      store.commit("adultAptPass/SET_PASS_TYPE", item)
      store.commit("dashboardTable/SET_DASHBOARD_UPDATES", false)
      store.dispatch("adultAptPass/getAppointmentPasses")
    }
    return {
      state,
      quickFilter,
      passType,
      activeTab,
      setQuickFilter,
      setPassType,
      passTypeSelectLabel
    }
  }
}
</script>

<style scoped lang="scss">
/* WCAG 1.4.10: reflow at 400% zoom — allow filter row to wrap; cap dropdown width to parent */
.apt-pass-filters {
  box-sizing: border-box;
}

.apt-pass-filter-dropdown {
  min-width: 0;
  max-width: 100%;
  flex: 1 1 auto;

  :deep(.v3custom-dropdown) {
    max-width: 100%;
  }

  :deep(.custom-drop-down) {
    width: min(170px, 100%);
    max-width: 100%;
    box-sizing: border-box;
  }

  :deep(.dropdown-menu) {
    width: min(170px, 100%);
    max-width: 100%;
    box-sizing: border-box;
  }
}
</style>
